import { Colors, Services } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsDomainsStates } from '@sigmasms/shared-types'

import { buttonModes, components, icons, labelModes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.domainsUsers`)
      }
    }
  )
}
function renderSelector(h) {
  return h(
    components.select,
    {
      props: {
        value: this.domainIds,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.domains`),
        service: Services['url-shortener-settings/domains'],
        query: { state: EUrlShortenerSettingsDomainsStates.active },
        required: this.required,
        clearable: !this.required,
        loading: this.createLoading || this.loading,
        disabled: this.createLoading,
        setRequiredOnMounted: false,
        itemTitle: 'name',
        labelMode: labelModes.hidden,
        dense: true,
        multiple: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.domainIds = event
        },
        search: event => {
          this.search = event
        }
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderInfo.call(this, h),
      renderSelector.call(this, h)
    ]
  )
}

function renderActionButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.save'),
        icon: icons.save,
        color: Colors.primary,
        mode: buttonModes.flat,
        loading: this.createLoading,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.createDomainsUsers()
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [ renderActionButton.call(this, h) ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

function renderCard(h) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pa-2',
      props: {
        outline: true,
        rounded: true
      }
    },
    [ renderContent.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'pa-2'
    },
    [ renderCard.call(this, h) ]
  )
}
